import { intakeFormDataKeys } from '@/views/SeroSurveyPage/data/instake-form-data-keys';
import contentTranslations from './translations/static-content-translations.json';

export default () => ({
  baseUrlApi: 'https://api.dvgapp.org',
  baseUrlTestApi: 'https://test.dvgapp.org',
  baseUrlHoHApi: 'https://api.labhoh.app',
  baseUrlHoHTestApi: 'https://api-test.labhoh.app',
  baseUrlContentApi: 'https://tourist.dvgapp.org',
  config: {
    loader: {
      show: false,
      text: null
    },
    snackbar: {
      open: false,
      text: null,
      showCloseButton: false,
      timeout: 4000,
      color: 'info'
    },
    selectedLanguage: null,
    defaultLanguage: 'papiamento',
    submitFormLanguage: 'dutch',
    contentTranslations: contentTranslations,
    languages: [
      {
        id: 1,
        label: {
          papiamento: 'Papiamento',
          spanish: 'Papiamento',
          dutch: 'Papiaments'
        },
        slug: 'papiamento'
      },
      {
        id: 2,
        label: {
          papiamento: 'Spaño',
          spanish: 'Español',
          dutch: 'Spaans'
        },
        slug: 'spanish'
      },
      {
        id: 3,
        label: {
          papiamento: 'Hulandes',
          spanish: 'Holandés',
          dutch: 'Nederlands'
        },
        slug: 'dutch'
      }
    ],
    recaptcha: '6Ld-RQ8aAAAAALKzU82ag7Zg_K6UbMdHm99peSCK'
  },
  intakeFormData: {
    formDataPrestine: new intakeFormDataKeys(),
    formData: new intakeFormDataKeys(),
    currentStep: 1,
    housemateCnt: 0,
    patientCase: [],
    patientCases: [],
    doctorOptions: [],
    code: null,
    codeId: null
  },
  auth: {
    authenticated: null,
    userObject: null,
    accessToken: '',
    refreshToken: '',
    loginUrl: '',
    logoutUrl: ''
  },
  appointmentsCalendarPage: {
    calendarEvents: [],
    currentCalendarRange: null,
    showTimeSlotDialog: false,
    calendarLoader: false,
    clickedDate: null,
    locations: [],
    location: null
  },
  appointmentsSelectedDayPage: {
    showAppointmentBookingDialog: false,
    selectedAppoinmentDateTime: null,
    appointments: [],
    loadingAppointments: false,
    selectedDate: null,
    timeSlots: [],
    loadingSlots: false,
    selectedSlot: null,
    confirmDeleteDialog: false,
    rescheduleAppointmentDialog: false,
    currentSelectedSlotId: null
  },
  createUserPage: {
    addresses: []
  }
});
